import { styled } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';

// `vars`, or the light value freezes into the class. The surface goes on the rounded field,
// like .input-field in app/style.css.
export const ICSDesktopDatePicker = styled(DesktopDatePicker)(({ theme }) => ({
  margin: '5px 10px 5px 0',
  '& .MuiOutlinedInput-root, & .MuiPickersOutlinedInput-root': {
    backgroundColor: (theme.vars || theme).palette.inputBackground,
  },
}));

export default ICSDesktopDatePicker;
